import script from "./CreatePlaylistCta.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePlaylistCta.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__